export default __webpack_public_path__ + "static/media/09.6acb3e1f.jpg";